"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutConfirmDialog = void 0;
var _userLogoutConfirmation = require("@ori-events/user-logout-confirmation");
var _userLogoutConfirmed = require("@ori-events/user-logout-confirmed");
var _configurationManager = require("@ori/configuration-manager");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("../../constants");
var _logger2 = require("../../logger");
var _ConfirmationDialog = require("../ConfirmationDialog/ConfirmationDialog");
var _jsxRuntime = require("react/jsx-runtime");
const LogoutConfirmDialog = () => {
  const {
    eshopUrl
  } = (0, _configurationManager.useServiceUrls)([]);
  const {
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useDisclose)();
  const handleConfirmation = (0, _react.useCallback)(() => {
    window.dispatchEvent(new CustomEvent(_userLogoutConfirmed.Name));
  }, []);
  const handleCancel = (0, _react.useCallback)(() => {
    // Timeout to allow for window close animation to finish.
    setTimeout(() => {
      onClose();
    }, 1000);
  }, [onClose]);
  const events = (0, _react.useMemo)(() => [{
    name: _userLogoutConfirmation.Name,
    listener: onOpen
  }], [onOpen]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: "LogoutConfirmDialog",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_i18n.TranslationsNamespaceProvider, {
        namespace: _constants.translationsNamespace,
        children: [open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfirmationDialog.ConfirmationDialog, {
          onConfirm: handleConfirmation,
          onCancel: handleCancel
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "js-logout-data",
          "data-url-eshoplogout": eshopUrl ? `${eshopUrl}/iframe/internal/Services.aspx` : null
        })]
      })
    })
  });
};
exports.LogoutConfirmDialog = LogoutConfirmDialog;
